function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M12 18.25c-4.115 0-7.66-2.566-9.192-6.25C4.34 8.316 7.885 5.75 12 5.75s7.66 2.566 9.192 6.25c-1.532 3.684-5.077 6.25-9.192 6.25z",
  stroke: "#000",
  strokeWidth: 1.5
});

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 12,
  cy: 12,
  r: 3.25,
  stroke: "#000",
  strokeWidth: 1.5
});

function SvgPreviewIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none"
  }, props), _ref, _ref2);
}

export default SvgPreviewIcon;